var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.058 1.75a3.75 3.75 0 0 1 3.75 3.75v13a3.75 3.75 0 0 1-3.75 3.75h-5a3.75 3.75 0 0 1-3.75-3.75V18a1.25 1.25 0 1 1 2.5 0v.5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-13c0-.69-.56-1.25-1.25-1.25h-5c-.69 0-1.25.56-1.25 1.25V6a1.25 1.25 0 0 1-2.5 0v-.5a3.75 3.75 0 0 1 3.75-3.75zM6.653 6.03a1.25 1.25 0 0 1 1.759 1.76l-.086.094-2.867 2.866h8.983a1.25 1.25 0 1 1 0 2.5H5.459l2.867 2.866a1.25 1.25 0 1 1-1.768 1.768l-5-5a1.25 1.25 0 0 1 0-1.768l5-5z"
  })));
};
export default SvgExit;